const Mtop = {
  config (k, v) {
    window.lib.mtop.config[k] = v
  },
  request (api, option = {}) {
    return new Promise((resolve, reject) => {
      window.lib.mtop.request(
        {
          api: api,
          v: option.v || '1.0',
          data: option.data || {},
          ecode: 0,
          appKey: window.lib.mtop.config.appKey || '24679788'
        },
        res => {
          var ret = res.ret.join(',')
          if (ret.indexOf('SUCCESS') > -1) {
            resolve(res)
          } else {
            reject(res)
          }
        },
        e => {
          reject(e)
        }
      )
    })
  }
}
export default Mtop
